export const pageRoutes = {
  Home: "/",
  About: "/about",
  Events: "/events",
  Sermons: "/sermons",
  Donations: "/donations",
  Calendar: "/calendar",
  Contact: "/contact",
  Login: "/login",
  MemberPortal: "/member-portal",
  MemberRegister: "/members/register",
  MemberVerifyEmail: "/members/verify-email",
  ForgotPassword: "/forgot-password",
  ResetPassword: "/reset-password",
  ConfirmEmailChange: "/confirm-email-change",
  MemberLogin: "/members/login",
  MemberDashboard: "/members/dashboard",
  MemberDashboardProfile: "/members/dashboard/profile",
  MemberDashboardPayments: "/members/dashboard/payments",
  MemberDashboardMembership: "/members/dashboard/membership",
  MemberDashboardSettings: "/members/dashboard/settings",
  MemberPaymentSuccess: "/members/payment-success",
  MemberPaymentCancelled: "/members/payment-cancelled",
  AdminLogin: "/admin/login",
  AdminDashboard: "/admin/dashboard",
  AdminMembers: "/admin/members",
  AdminMemberDetail: "/admin/members/:id",
  AdminPayments: "/admin/payments",
  AdminSettings: "/admin/settings",
};

export function createPageUrl(pageName) {
  return pageRoutes[pageName] || pageRoutes.Home;
}
